import React from 'react';

const Layout = ({
  Component,
  ...pageProps
}: {
  Component: React.ComponentType;
}) => <Component {...pageProps} />;
export default Layout;
